import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout'
import ServiceHome from '../views/ServiceHome'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Root',
    component: Layout,
    redirect: "/serviceHome",
    children: [
      {
        path: '/serviceHome',
        name: 'ServiceHome',
        component: ServiceHome,
        meta:{
          isLogin:false
        }
      },

      {
        path: '/serviceList',
        name: 'serviceList',
        component: () => import(/* webpackChunkName: "about" */ '../views/ServiceList.vue'),
        meta:{
          isLogin:false
        }
      },
      {
        path: '/serviceInfor',
        name: 'serviceInfor',
        component: () => import(/* webpackChunkName: "about" */ '../views/ServiceInfor.vue'),
        meta:{
          isLogin:false
        }

      },
      
      {
        path: '/graduateFileInfor',
        name: 'graduateFileInfor',
        component: () => import(/* webpackChunkName: "about" */ '../views/graduateFile/index.vue'),
        meta:{
          isLogin:false
        },
        props:{data:{type:String}},
      },
      {
        path: '/medicalInsurance',
        name: 'medicalInsurance',
        component: () => import(/* webpackChunkName: "about" */ '../views/medicalInsurance/index.vue'),
        meta:{
          isLogin:false
        },
        props:{data:{type:String}},
      },
      {
        path: '/accessAuthorization',
        name: 'accessAuthorization',
        component: () => import(/* webpackChunkName: "about" */ '../views/accessAuthorization/index.vue'),
        meta:{
          isLogin:false
        },
        props:{data:{type:String}},
      },
      {
        path: '/admissionRosterCopy',
        name: 'admissionRosterCopy',
        component: () => import(/* webpackChunkName: "about" */ '../views/admissionRosterCopy/index.vue'),
        meta:{
          isLogin:false
        },
        props:{data:{type:String}},
      },
      {
        path: '/myHome',
        name: 'myHome',
        component: () => import(/* webpackChunkName: "about" */ '../views/MyHome.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/index.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter/mailList',
        name: 'mailList2',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/mailList.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter/notice',
        name: 'notice',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/notice.vue'),
        meta:{
          isLogin:true
        }      
      },
      {
        path: '/userCenter/noticeInfo',
        name: 'noticeInfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/noticeInfo.vue'),
        meta:{
          isLogin:true
        }      
      },
      {
        path: '/userCenter/userMsg',
        name: 'userMsg',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/userMsg.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter/userMsgInfo',
        name: 'userMsgInfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/userMsgInfo.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter/schoolCalendar',
        name: 'schoolCalendar',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/schoolCalendar.vue'),
        meta:{
          isLogin:true
        }       
      },
      {
        path: '/userCenter/curriculum_stu',
        name: 'curriculum_stu',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/curriculum_student.vue'),
        meta:{
          isLogin:true
        }       
      },
      {
        path: '/userCenter/curriculum_teacher',
        name: 'curriculum_teacher',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/curriculum_teacher.vue'),
        meta:{
          isLogin:true
        }       
      },
      {
        path: '/userCenter/matterInfo',
        name: 'matterInfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/matterInfo.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/userCenter/matterApproval',
        name: 'matterApproval',
        component: () => import(/* webpackChunkName: "about" */ '../views/userCenter/matterApproval.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/feedback',
        name: 'feedback',         
        component: () => import(/* webpackChunkName: "about" */ '../views/Feedback.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/feedbackDetail',
        name: 'feedbackDetail',         
        component: () => import(/* webpackChunkName: "about" */ '../views/feedbackDetail.vue'),
        meta:{
          isLogin:true
        }
      },
      {
        path: '/schoolHistoryMuseumReservat',
        name: 'SchoolHistoryMuseumReservat',
        component: () => import(/* webpackChunkName: "about" */ '../views/SchoolHistory/SchoolHistoryMuseumReservat.vue'),
        meta:{
          isLogin:false
        }
      }, {
        path: '/SMRDetaile',
        name: 'SMRDetaile',
        component: () => import(/* webpackChunkName: "about" */ '../views/SchoolHistory/SMRDetaile.vue'),
        meta:{
          isLogin:false
        }
      }, 
      {
        path: '/supplierEntry',
        name: 'supplierEntry',
        component: () => import(/* webpackChunkName: "about" */ '../views/supplierEntry/index.vue'),
        meta:{
          isLogin:false
        },
      },
      {
        path: '/archiveQuery',
        name: 'archiveQuery',
        component: () => import(/* webpackChunkName: "about" */ '../views/archiveQuery/index.vue'),
        meta:{
          isLogin:false
        },
        props:{data:{type:String}},
      },
    ]
  },
  {
    path: '/feedbackDetailIframe',
    name: 'feedbackDetailIframe',         
    component: () => import(/* webpackChunkName: "about" */ '../views/feedbackDetailIframe.vue'),
    meta:{
      isLogin:true
    }
  },
  {
    path: '/SMRDetaileIframe',
    name: 'SMRDetaile',
    component: () => import(/* webpackChunkName: "about" */ '../views/SchoolHistory/SMRDetaile.vue'),
    meta:{
      isLogin:true
    }
  }, 
  {
    path: '/accessAuthorizationDetailIframe',
    name: 'accessAuthorizationDetailIframe',
    component: () => import(/* webpackChunkName: "about" */ '../views/accessAuthorization/accessAuthorizationDetaile.vue'),
    meta:{
      isLogin:true
    }
  }, 
  {
    path: '/admissionRosterCopyDetaileIframe',
    name: 'admissionRosterCopyDetaileIframe',
    component: () => import(/* webpackChunkName: "about" */ '../views/admissionRosterCopy/admissionRosterCopyDetaile.vue'),
    meta:{
      isLogin:true
    }
  }, 
  {
    path: '/waitingToLogin',
    name: 'getTokens',
    component: () => import('../views/getTokens.vue'),
    meta:{
      isLogin:false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta:{
      isLogin:false
    }
  },
   // cas扫码登录加载页面
  {
    path: '/wxloding',
    name: 'wxloding',
    component: () => import(/* webpackChunkName: "about" */ '../views/wxAndQywxLogin/wxloding.vue'),
    meta:{
      isLogin:false
    },
    props:{data:{type:String}},
  },
  {
    path: '/qywxloding',
    name: 'qywxloding',
    component: () => import(/* webpackChunkName: "about" */ '../views/wxAndQywxLogin/qywxloding.vue'),
    meta:{
      isLogin:false
    },
    props:{data:{type:String}},
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/wxAndQywxLogin/register.vue'),
    meta:{
      isLogin:false
    },
    props:{data:{type:String}},
  },
  {
    path: '/archiveQueryDetails',
    name: 'archiveQueryDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/archiveQuery/details.vue'),
    meta:{
      isLogin:true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// router.afterEach(to => {
//   // 设置title
//   document.title = to.meta.title;
// })



export default router
